module.exports = __webpack_public_path__ + "static/media/backMobile.91e874d9.svg";